import React, { useEffect, useState } from "react";
import { PageLayout } from "../../components/page-layout";
import { OnboardingProgressBar } from "../../components/onboarding-progress-bar";
import { useNavigate } from "react-router-dom";
import { useOnboarding } from "../../providers/onboarding-provider";
import { FormShell } from "../../components/onyx/FormShell";
import { FormActions } from "../../components/onyx/Field";
import { Button } from "../../components/onyx/Button";

const ATTUNE_CLINIC_NAME = "Attune Health";

export const ThankYouPage = () => {
  const navigate = useNavigate();
  const { fetchOnboardingStatus } = useOnboarding();
  const [flowName, setFlowName] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const data = await fetchOnboardingStatus({ silent: true });
      if (cancelled || !data) {
        return;
      }
      setFlowName(data.flow_name || null);
    })();
    return () => {
      cancelled = true;
    };
  }, [fetchOnboardingStatus]);

  const isAttune = flowName === "attune";

  return (
    <PageLayout>
      <div className="content-layout">
        <OnboardingProgressBar />
        <FormShell>
          <h1 id="page-title" className="content__title">
            {isAttune ? "You're all set" : "Thank You"}
          </h1>

          {isAttune ? (
            <>
              <p className="content__body">
                Thanks for completing onboarding. Check your email for your
                signed consent and a link to schedule your study visit at{" "}
                {ATTUNE_CLINIC_NAME}.
              </p>
              <p className="content__body">
                Questions? Email{" "}
                <a href="mailto:members@onyx.bio">members@onyx.bio</a>.
              </p>
            </>
          ) : (
            <>
              <p className="content__body">
                Thanks for joining Onyx! We&apos;ll be in touch soon about next steps.
              </p>
              <p className="content__body">
                If you have any questions, please reach out to us at
                <a href="mailto:members@onyx.bio"> members@onyx.bio</a>.
              </p>
            </>
          )}

          <FormActions className="prescreen-actions-center">
            <Button
              type="button"
              variant="primary"
              onClick={() => navigate("/dashboard")}
            >
              Go to Dashboard
            </Button>
          </FormActions>
        </FormShell>
      </div>
    </PageLayout>
  );
};
